import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { ChatbotModal } from "./components/ChatbotModal";
import { Footer } from "./components/Footer";
import { LoginView } from "./views/LoginView";
import { ConsultasView } from "./views/ConsultasView";
import { InicioView } from "./views/InicioView";
import { NosotrosView } from "./views/NosotrosView";
import { ComoFuncionaView } from "./views/ComoFuncionaView";

const WHATSAPP_NUMBER = "593983930386";

const HomePage = () => {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [view, setView] = useState(location.state?.view || "inicio"); // 'inicio', 'consultas', 'nosotros', 'como-funciona', 'login'
  const [chatOpen, setChatOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("es-EC", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(amount || 0);
  };

  const changeView = (newView) => {
    setView(newView);
    setMobileMenuOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const openWhatsApp = (msg) => {
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
    window.open(url, "_blank");
  };

  const renderContent = () => {
    switch (view) {
      case "login":
        return <LoginView setView={setView} openWhatsApp={openWhatsApp} />;
      case "consultas":
        return <ConsultasView formatCurrency={formatCurrency} />;
      case "nosotros":
        return <NosotrosView />;
      case "como-funciona":
        return <ComoFuncionaView setView={setView} />;
      case "inicio":
      default:
        return <InicioView setView={setView} />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 font-sans text-gray-800 flex flex-col selection:bg-blue-100 selection:text-blue-700">
      <Navbar
        scrolled={scrolled}
        view={view}
        changeView={changeView}
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
      />

      <main className="flex-grow">{renderContent()}</main>

      <ChatbotModal 
        chatOpen={chatOpen} 
        setChatOpen={setChatOpen} 
        changeView={changeView} 
        openWhatsApp={openWhatsApp} 
      />

      <Footer changeView={changeView} />
    </div>
  );
};

export default HomePage;
